
(function(){
  if(window.__abxAddonInit) { window.__abxAddonScan && window.__abxAddonScan(); return; }
  window.__abxAddonInit = 1;
  var W = window;
  var ADDON_PCT = (window.__abxCfg && +window.__abxCfg.addonDiscPct) || 0;
  function addonDiscCents(raw){ return ADDON_PCT>0 ? Math.round(raw*(1-ADDON_PCT/100)) : raw; }

  function money(cents, cur){
    try{ var h = W.Alpine && Alpine.store && Alpine.store('xHelper'); if(h && h.formatMoney) return h.formatMoney(cents, cur); }catch(e){}
    return '$' + (Math.round(cents)/100).toFixed(2);
  }

  if(false){ window.__abAddDedup=1; (function(){
    var last={}, lastAny=0;
    function vof(b){ var ids=[]; try{
      if(b==null) return ids;
      if(typeof b==='string'){ try{ var d=JSON.parse(b); if(d){ if(d.id!=null)ids.push(String(d.id)); if(d.items&&d.items.length)d.items.forEach(function(i){ if(i&&i.id!=null)ids.push(String(i.id)); }); } }catch(e){ try{ new URLSearchParams(b).getAll('id').forEach(function(v){ if(v)ids.push(String(v)); }); }catch(e2){} } }
      else if(b && typeof b.get==='function'){ var x=b.get('id'); if(x!=null)ids.push(String(x)); }
    }catch(e){} return ids; }
    function dup(b){ var ids=vof(b), now=Date.now(), d=false;
      if(ids.length){ ids.forEach(function(k){ if(last[k]&&(now-last[k])<1500)d=true; last[k]=now; }); }
      else if(lastAny && (now-lastAny)<400){ d=true; }
      lastAny=now;
      try{ console.log('[AB-ADD]', d?'BLOCKED dup':'pass', 'ids='+JSON.stringify(ids), 'body='+(typeof b), (new Error().stack||'').split('\n').slice(2,5).join('  ⟵  ')); }catch(e){}
      return d; }
    function wrapFetch(){ var of=window.fetch; if(!of||of.__abdd) return; window.fetch=function(){ var a=arguments, url=(a[0]&&a[0].url)||a[0]||''; if(typeof url==='string' && url.indexOf('/cart/add')>-1){ var init=a[1]; if(init && init.__abseen){ return of.apply(this, a); } if(dup(init&&init.body)){ return of.call(window,'/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'}); } try{ if(init) init.__abseen=1; }catch(e){} } return of.apply(this, a); }; window.fetch.__abdd=1; }
    wrapFetch();
    try{ var XO=window.XMLHttpRequest; if(XO && XO.prototype && !XO.prototype.__abdd){ var op=XO.prototype.open, sd=XO.prototype.send;
      XO.prototype.open=function(m,u){ this.__abu=(u||''); return op.apply(this, arguments); };
      XO.prototype.send=function(b){ try{ if(typeof this.__abu==='string' && this.__abu.indexOf('/cart/add')>-1 && dup(b)){ try{ op.call(this,'GET','/cart.js'); return sd.call(this); }catch(e){} } }catch(e){} return sd.apply(this, arguments); };
      XO.prototype.__abdd=1; } }catch(e){}
  })(); }
  window.__abCanAdd = window.__abCanAdd || function(vid){ try{ var k=String(vid),now=Date.now(),L=(window.__abAddLock=window.__abAddLock||{}); if(L[k]&&(now-L[k])<1500)return false; L[k]=now; return true; }catch(e){ return true; } };
  function addItems(items){
    items=(items||[]).filter(function(it){ return window.__abCanAdd(it.id); });
    if(!items.length) return Promise.resolve(null);
    var ch=null, secIds=null;
    try{ ch = W.Alpine && Alpine.store && Alpine.store('xCartHelper'); }catch(e){}
    try{ if(ch && ch.getSectionsToRender) secIds = ch.getSectionsToRender().map(function(x){return x.id}); }catch(e){}
    var body={items:items};
    if(secIds){ body.sections=secIds; body.sections_url=location.pathname; }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify(body)})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,status:r.status,data:d}; }); })
      .then(function(res){
        if(!res.ok){ var e=new Error('add'); e.payload=res.data; e.status=res.status; throw e; }
        var d=res.data;
        try{ document.dispatchEvent(new CustomEvent('cart:refresh')); }catch(e){}
        try{ document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:d}})); }catch(e){}
        try{ document.dispatchEvent(new CustomEvent('product:added',{detail:d,bubbles:true})); }catch(e){}
        var rendered=false;
        try{ var c2=Alpine.store('xCartHelper'); if(d&&d.sections&&c2&&c2.reRenderSections){ c2.reRenderSections(d.sections); rendered=true; } }catch(e){}
        try{ var mc=Alpine.store('xMiniCart'); if(mc){ if(rendered){ mc.needReload=false; } else { mc.needReload=true; if(mc.reLoad) mc.reLoad(); } if(mc.openCart) mc.openCart(); } }catch(e){}
        try{ document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); }catch(e){}
        return d;
      });
  }

  function vidOf(t){ return parseInt(t.getAttribute('data-vid'),10); }

  function wire(root){
    if(!root || root.__abx) return;
    root.__abx = true;
    var mode  = root.getAttribute('data-abx-mode') || 'instant';
    var src   = root.getAttribute('data-abx-source') || 'manual';
    var cur   = root.getAttribute('data-currency') || 'AUD';
    var sid   = root.getAttribute('data-abx-sid') || '';
    var bundleMode = (mode==='bundle' || mode==='unified');
    var showRemove = root.getAttribute('data-abx-showremove')==='true';
    var bundleFab = root.getAttribute('data-abx-bundlefab')==='true';
    var rail  = root.querySelector('[data-abx-rail]');
    var prev  = root.querySelector('[data-abx-prev]');
    var next  = root.querySelector('[data-abx-next]');
    var foot  = root.querySelector('[data-abx-foot]');
    if(foot && bundleMode && sid){ var _bHost=document.querySelector('.cv-ps-'+sid+' [data-abx-bundle-host]'); if(_bHost){ foot.classList.add('abx__foot--relocated'); _bHost.appendChild(foot); } }
    var L = { add:root.getAttribute('data-cta')||'Add', added:root.getAttribute('data-cta-added')||'Added',
              set:root.getAttribute('data-cta-set')||'Add to set', sel:root.getAttribute('data-cta-selected')||'Added' };
    var discLabel = root.getAttribute('data-bundle-disc-label')||'5% Extra bundle discount';
    var bundleTitleOverride = root.getAttribute('data-bundle-title')||'';
    var selected = {};
    var pollTimer = null, pastBuyBox = false, atcOrig = null, atcCta = null, fab = null, tierAllowed = true;

    function setLabel(tile, txt){ var t=tile.querySelector('.abx-tile__cta-txt'); if(t) t.textContent=txt; }
    function selVids(){ return Object.keys(selected).map(Number); }

    function alpineData(){
      try{ var el=document.querySelector('.cv-ps-'+sid+' [x-data]'); if(!el) return null;
        return el._x_dataStack ? el._x_dataStack[0] : (W.Alpine&&Alpine.$data?Alpine.$data(el):null); }catch(e){ return null; }
    }
    function kitData(){
      var d=alpineData(); if(!d) return null; var v=null; try{ v=d.cv_; }catch(e){}
      if(!v) return null;
      return { vid:v.id, price:v.price||0, compareAt:v.compare_at_price||0, avail:v.available!==false, img:(d.heroImg||v.featured_image||''),
        label:(d.cm&&d.cm.name)?d.cm.name:'Your kit',
        colour:(function(){ try{ if(typeof d.duoLabel==='function') return d.duoLabel(false); return d.cname ? d.cname(d.selectedColor) : (d.selectedColor||''); }catch(e){ return ''; } })(),
        colourShort:(function(){ try{ if(typeof d.duoLabel==='function') return d.duoLabel(true); return d.cname ? d.cname(d.selectedColor) : (d.selectedColor||''); }catch(e){ return ''; } })(),
        sqProps:(function(){ try{ return d._sqProps ? d._sqProps() : {}; }catch(e){ return {}; } })(),
        fmt:function(c){ try{ return d.fw?d.fw(c):money(c,cur); }catch(e){ return money(c,cur); } } };
    }
    function fmtMoney(c){ var k=kitData(); return k?k.fmt(c):money(c,cur); }
    function addonTotal(){ var t=0; Object.keys(selected).forEach(function(v){ t+=(selected[v].price||0)*(selected[v].qty||1); }); return t; }

    function miniHTML(img,isKit){ return '<div class="abx-mini'+(isKit?' abx-mini--kit':' abx-mini--addon')+'"><img src="'+(img||'')+'" alt="" loading="lazy"><span class="abx-mini__tag'+(isKit?'':' abx-mini__tag--addon')+'">'+(isKit?'Kit':'Add-on')+'</span></div>'; }
    function stripHTML(){
      var k=kitData(), h='';
      if(k&&k.vid){ h+=miniHTML(k.img,true); if(selVids().length) h+='<span class="abx-plus">+</span>'; }
      Object.keys(selected).forEach(function(v){ h+=miniHTML(selected[v].img||'',false); });
      return h;
    }
    function desiredMinis(){
      var k=kitData(), list=[];
      if(k&&k.vid){ list.push({key:'k', img:k.img||'', kit:true}); if(selVids().length) list.push({key:'+', plus:true}); }
      Object.keys(selected).forEach(function(v){ list.push({key:'a'+v, img:selected[v].img||''}); });
      return list;
    }
    function renderStrip(box){
      if(!box) return;
      var want=desiredMinis(), have={};
      [].forEach.call(box.children, function(ch){ var kk=ch.getAttribute('data-k'); if(kk!=null) have[kk]=ch; });
      var prev=null;
      want.forEach(function(d){
        var node=have[d.key];
        if(node){ delete have[d.key]; if(!d.plus){ var im=node.querySelector('img'); if(im && im.getAttribute('src')!==d.img) im.src=d.img; } }
        else if(d.plus){ node=document.createElement('span'); node.className='abx-plus'; node.textContent='+'; node.setAttribute('data-k','+'); }
        else { node=document.createElement('div'); node.className='abx-mini'+(d.kit?' abx-mini--kit':' abx-mini--addon'); node.setAttribute('data-k',d.key);
          var img=document.createElement('img'); img.alt=''; img.loading='lazy'; img.src=d.img||''; node.appendChild(img);
          var tg=document.createElement('span'); tg.className='abx-mini__tag'+(d.kit?'':' abx-mini__tag--addon'); tg.textContent=d.kit?'Kit':'Add-on'; node.appendChild(tg); }
        var ref=prev?prev.nextSibling:box.firstChild;
        if(ref!==node) box.insertBefore(node, ref);
        prev=node;
      });
      Object.keys(have).forEach(function(kk){ box.removeChild(have[kk]); });
    }
    function setHTMLDiff(el, html){ if(!el) return; if(el.__abxHTML===html) return; el.__abxHTML=html; el.innerHTML=html; }

    function addBundle(btn){
      var vids=selVids(); if(!vids.length) return Promise.resolve();
      if(window.__abxBundleBusy) return Promise.resolve();
      window.__abxBundleBusy=true;
      try{ var _mc=W.Alpine&&Alpine.store&&Alpine.store('xMiniCart'); if(_mc&&_mc.openCart) _mc.openCart(); }catch(e){}
      try{ var _h=document.querySelector('#CartDrawer-Form')||document.querySelector('#CartDrawer .ab-cart-scroll'); if(_h&&!_h.querySelector('.ab-atc-skel')){var _sk=document.createElement('div');_sk.className='ab-atc-skel';_sk.innerHTML='<div class="ab-atc-skel-img"></div><div class="ab-atc-skel-lines"><i></i><i></i></div>';_h.insertBefore(_sk,_h.firstChild);} }catch(e){}
      var k=kitData();
      var addonItems=vids.map(function(v){ return {id:v,quantity:((selected[v]&&selected[v].qty)||1),properties:{_gate_ok:'1'}}; });
      if(btn){ btn.disabled=true; }
      function finish(){ window.__abxBundleBusy=false; clearSel(); if(btn){ btn.disabled=false; } refreshBundleUI(); }
      var ad=alpineData(), _discReady=Promise.resolve(), _own=window.__abDiscount;
      if(ad&&ad.discActive&&ad.discountCode&&!_own){
        var _dId='cv-disc-iframe-abx';var _old=document.getElementById(_dId);if(_old)_old.remove();
        var _dIfr=document.createElement('iframe');_dIfr.id=_dId;_dIfr.style.display='none';
        document.body.appendChild(_dIfr);_dIfr.src='/discount/'+encodeURIComponent(ad.discountCode);
        _discReady=new Promise(function(r){_dIfr.addEventListener('load',r);setTimeout(r,3000)});
      }
      return _discReady.then(function(){return fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
        .then(function(r){ return r.json(); }).catch(function(){ return {items:[]}; })
        .then(function(cart){
          var hasKit = k && k.vid && (cart.items||[]).some(function(it){ return it.id===k.vid; });
          var needKit = k && k.vid && k.avail && !hasKit;
          if(needKit){
            return addItems([{id:k.vid,quantity:1,properties:(k.sqProps||{})}])
              .then(function(){ return new Promise(function(res){ setTimeout(res, 700); }); })
              .then(function(){ return addItems(addonItems); });
          }
          return addItems(addonItems);
        })
        .then(function(d){
          if(_own&&ad&&ad.discActive&&ad.discountCode){ _own.apply([ad.discountCode]).then(_own.paint).catch(function(){}); }
          return d;
        })
        .then(finish, finish)});
    }

    function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    function bundleBreakdown(){
      var k=kitData(), d=discData(), ad=alpineData();
      var discAvail=!!(ad && ad.discountEnabled && typeof ad._discountPrice==='function');
      var discOn=!!d;
      function disc1(raw){ if(!d) return raw; try{ var x=d._discountPrice(raw); return x<raw?x:raw; }catch(e){ return raw; } }
      function hypo1(raw){ if(!ad||typeof ad._discountPrice!=='function') return raw; try{ var x=ad._discountPrice(raw); return x<raw?x:raw; }catch(e){ return raw; } }
      var _addonPct=(window.__abxCfg&&+window.__abxCfg.addonDiscPct)||0;
      function addonDisc(raw){ return _addonPct>0?Math.round(raw*(1-_addonPct/100)):raw; }
      var lines=[], rawSub=0, compareSub=0, discSub=0, hypoSub=0, names=[], n=0, codePct=0, codePctHypo=0, rawAddon=0, addonNow=0, kitAddonRaw=0, kitAddonNow=0;
      if(k&&k.vid){ var kr=k.price||0, kc=k.compareAt||0, kd=disc1(kr), kh=hypo1(kr); rawSub+=kr; compareSub+=(kc>kr?kc:kr); discSub+=kd; hypoSub+=kh; if(kr>0){ codePct=Math.round((kr-kd)/kr*100); codePctHypo=Math.round((kr-kh)/kr*100); } lines.push({name:(k.label||'Kit'), sub:(k.colour||''), raw:kr, now:kd, img:(k.img||''), qty:1, isKit:true, disc:(discOn&&kd<kr)}); }
      Object.keys(selected).forEach(function(v){ var it=selected[v]; var q=it.qty||1; n+=q; var baked=(!it.isKitAddon && (it.compare||0)>it.price); var rw=baked?it.compare:it.price; var dd=it.isKitAddon?disc1(it.price):(baked?it.price:addonDisc(it.price)); rawSub+=rw*q; compareSub+=rw*q; discSub+=dd*q; hypoSub+=dd*q; if(it.isKitAddon){kitAddonRaw+=rw*q; kitAddonNow+=dd*q;}else{rawAddon+=rw*q; addonNow+=dd*q;} lines.push({name:it.name, sub:it.sub, raw:rw, now:dd, img:it.img, qty:q, vid:v, isKit:false, isKitAddon:!!it.isKitAddon, disc:(dd<rw)}); names.push(it.name); });
      var bundled=!!(k&&k.vid)&&n>0;
      var _bxBase = (window.__abxCfg && window.__abxCfg.bundleExtraPct != null) ? +window.__abxCfg.bundleExtraPct : 0;
      var bundlePct = _bxBase > 0 ? ((n>=2) ? _bxBase*2/100 : _bxBase/100) : 0;
      var bundleOff=bundled?Math.round(discSub*bundlePct):0, totalNow=discSub-bundleOff, totalSaved=compareSub-totalNow;
      var hypoOff=rawSub-hypoSub;
      var hypoPct=rawSub>0?Math.round(hypoOff/rawSub*100):0;
      var kitRaw=rawSub-rawAddon, kitNow=discSub-addonNow;
      return { lines:lines, rawSub:rawSub, compareSub:compareSub, discSub:discSub, saleOff:(rawSub-discSub), saleOffKit:(kitRaw-kitNow), hypoOffKit:(kitRaw-(hypoSub-addonNow-kitAddonNow)), addonOff:(rawAddon-addonNow), addonPct:_addonPct, kitAddonOff:(kitAddonRaw-kitAddonNow), bundleOff:bundleOff, bundlePct:bundlePct, totalNow:totalNow, totalSaved:totalSaved, n:n, k:k, names:names, hasDisc:discOn, discAvail:discAvail, hypoOff:hypoOff, hypoPct:hypoPct, codePct:codePct, codePctHypo:codePctHypo };
    }
    function footLinesHTML(b){
      if(!b.n) return '';
      var _bundleAddPct = (b.bundleOff>0?Math.round(b.bundlePct*100):0);
      var h='', d=alpineData();
      b.lines.forEach(function(l){
        var priceHTML = (l.disc&&l.now<l.raw)
          ? '<span class="abx__fl-price abx__fl-price--stack"><span class="abx__fl-now">'+fmtMoney(l.now)+'</span><s class="abx__fl-was">'+fmtMoney(l.raw)+'</s></span>'
          : '<span class="abx__fl-price"><span class="abx__fl-now">'+fmtMoney(l.raw)+'</span></span>';
        var isItem = l.img!==undefined;
        var ic = isItem
          ? '<span class="abx-mini abx-mini--row'+(l.isKit?' abx-mini--kit':' abx-mini--addon')+'"><img src="'+esc(l.img)+'" alt="" loading="lazy"><span class="abx-mini__tag'+(l.isKit?'':' abx-mini__tag--addon')+'">'+(l.isKit?'Kit':'Add-on')+'</span></span>'
          : '';
        var _lineSave = l.raw - l.now;
        var _kpill = (isItem && _lineSave>0) ? '<span class="abx__fl-kitpct">'+fmtMoney(_lineSave)+' off</span>' : '';
        var nameCell;
        if (l.isKit && d && d.isDuo && d.squareColor && d.squareColor !== d.selectedColor) {
          var _c1 = '<span class="abx__fl-cdot" style="background:'+esc(d.hex(d.selectedColor)||'#ccc')+'"></span>'+esc(d.cname(d.selectedColor));
          var _c2 = '<span class="abx__fl-cdot" style="background:'+esc(d.hex(d.squareColor)||'#ccc')+'"></span>'+esc(d.cname(d.squareColor));
          nameCell = '<span class="abx__fl-name abx__fl-name--pair"><span class="abx__fl-nmrow"><span class="abx__fl-nm">'+esc(l.name)+'</span>'+_kpill+'</span><span class="abx__fl-colour abx__fl-colour--row">'+_c1+'</span><span class="abx__fl-colour abx__fl-colour--row">'+_c2+'</span></span>';
        } else if (l.sub) {
          nameCell = '<span class="abx__fl-name abx__fl-name--pair"><span class="abx__fl-nmrow"><span class="abx__fl-nm">'+esc(l.name)+'</span>'+_kpill+'</span><span class="abx__fl-colour">'+esc(l.sub)+'</span></span>';
        } else {
          nameCell = '<span class="abx__fl-name">'+esc(l.name)+_kpill+'</span>';
        }
        var ctrl = (isItem && !l.isKit)
          ? '<span class="abx__fl-qty" data-abx-sum-vid="'+l.vid+'"><button type="button" class="abx__fl-step" data-abx-sum-dec aria-label="Decrease quantity">−</button><span class="abx__fl-qnum">'+(l.qty||1)+'</span><button type="button" class="abx__fl-step" data-abx-sum-inc aria-label="Increase quantity">+</button></span>'
          : '';
        var del = (showRemove && isItem)
          ? (l.isKit
              ? '<span class="abx__fl-del-gut" aria-hidden="true"></span>'
              : '<button type="button" class="abx__fl-del" data-abx-sum-vid="'+l.vid+'" data-abx-sum-del aria-label="Remove '+esc(l.name)+' from bundle">×</button>')
          : '';
        h+='<div class="abx__fl'+(isItem?' abx__fl--item':'')+'">'+del+ic+nameCell+'<div class="abx__fl-right">'+priceHTML+ctrl+'</div></div>';
      });
      h+='<div class="abx__fl-sep"></div>';
      if(b.bundleOff>0) h+='<div class="abx__fl abx__fl--disc"><span class="abx__fl-bdisc-ico" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1E47CE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v10H4V12"/><rect x="2" y="7" width="20" height="5" rx="1"/><path d="M12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg></span><span class="abx__fl-name">Extra bundle &amp; save discount</span><span class="abx__fl-price">−'+fmtMoney(b.bundleOff)+'</span></div>';
      if(b.addonOff>0){ h+='<div class="abx__fl abx__fl--disc"><span class="abx__fl-bdisc-ico" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1E47CE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v10H4V12"/><rect x="2" y="7" width="20" height="5" rx="1"/><path d="M12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg></span><span class="abx__fl-name">Add-on discount applied</span><span class="abx__fl-price">−'+fmtMoney(b.addonOff)+'</span></div>'; }
      if(b.saleOffKit>0||b.discAvail){ var _isOn=b.saleOffKit>0, _saleAmt=_isOn?b.saleOffKit:b.hypoOffKit, _offCls=_isOn?'':' abx__fl--disc-off', _chkCls=_isOn?'':' is-off'; h+='<div class="abx__fl abx__fl--disc abx__fl--badge'+_offCls+'"><span class="abx__fl-badge-ico" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 30 30" fill="none"><circle cx="15" cy="15" r="13" fill="#1E47CE"/><circle cx="15" cy="15" r="10" fill="none" stroke="rgba(255,255,255,.4)" stroke-width="1.5"/><rect x="12" y="5" width="6" height="20" rx="2" fill="#fff"/></svg></span><span class="abx__fl-name">Bundle discount applied</span><span class="abx__fl-check'+_chkCls+'" role="button" tabindex="0" aria-label="Toggle discount" data-abx-disc-toggle title="Toggle discount"><svg class="abx-chk-on" width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="1" y="1" width="22" height="22" rx="6" fill="#1E47CE"/><path d="M7 12.5L10.5 16L17 8.5" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><svg class="abx-chk-off" width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="1.5" y="1.5" width="21" height="21" rx="5.5" stroke="#1E47CE" stroke-width="1.5" fill="none"/></svg></span><span class="abx__fl-cdrow" data-abx-foot-cdrow hidden> ends <strong class="abx__fl-cdtxt" data-abx-foot-cdtxt></strong></span><span class="abx__fl-price">−'+fmtMoney(_saleAmt)+'</span></div>'; }
      var _shipWas=(window.__abxCfg&&window.__abxCfg.shipWasCents)||0;
      h+='<div class="abx__fl abx__fl--disc abx__fl--ship"><span class="abx__fl-plane" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1E47CE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2 11 13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></span><span class="abx__fl-name">Free Express Shipping</span><span class="abx__fl-cdrow" data-abx-foot-cdrow hidden> ends <strong class="abx__fl-cdtxt" data-abx-foot-cdtxt></strong></span><span class="abx__fl-price">'+(_shipWas>0?'<s style="font-weight:500;color:#5E6A85;margin-right:4px">'+fmtMoney(_shipWas)+'</s>':'')+fmtMoney(0)+'</span></div>';
      h+='<div class="abx__fl abx__fl--total"><span class="abx__fl-name">Total</span><span class="abx__fl-price">'+(b.totalSaved>0?('<s>'+fmtMoney(b.compareSub)+'</s> '):'')+fmtMoney(b.totalNow)+'</span></div>';
      if(b.totalSaved>0){ h+='<div class="abx__fl-save">Save −'+fmtMoney(b.totalSaved)+'</div>'; }
      return h;
    }
    function bundleHeadLabel(b){
      if(bundleTitleOverride) return bundleTitleOverride;
      var kn=(b.k&&b.k.vid)?(b.k.label||'Kit'):'';
      if(!kn) return b.n>0 ? (b.n+(b.n===1?' add-on':' add-ons')) : '';
      if(b.n===0) return kn;
      var nm = b.n===1 ? b.names[0] : (b.n+' add-ons');
      if(b.n===1 && nm.length>30) nm=nm.slice(0,29).replace(/\s+$/,'')+'…';
      return kn+' + '+nm;
    }
    function refreshBundleUI(){
      if(!bundleMode) return;
      var b=bundleBreakdown(), label=bundleHeadLabel(b);
      if(foot && sid){ var _rh=document.querySelector('.cv-ps-'+sid+' [data-abx-bundle-host]'); if(_rh && foot.parentNode!==_rh){ foot.classList.add('abx__foot--relocated'); _rh.appendChild(foot); } }
      if(foot){
        var fc=foot.querySelector('[data-abx-foot-count]'), ft=foot.querySelector('[data-abx-foot-total]'),
            fb=foot.querySelector('[data-abx-foot-btn]'), fs=foot.querySelector('[data-abx-foot-strip]'),
            fl=foot.querySelector('[data-abx-foot-lines]'), ftt=foot.querySelector('[data-abx-foot-title]');
        if(fc) fc.textContent=label; if(ft) ft.textContent=fmtMoney(b.totalNow);
        if(ftt){ var _bt=(window.__abxCfg&&window.__abxCfg.bundleTitle)||'Your bundle', _items=(b.n>0?' ('+(b.n+1)+' items)':''); ftt.textContent = (window.__abxCfg&&window.__abxCfg.simpleSummary) ? (b.n>0 ? _bt+_items : ((window.__abxCfg&&window.__abxCfg.selectionTitle)||'Your selection')) : (_bt+_items); }
        renderStrip(fs); setHTMLDiff(fl, footLinesHTML(b));
        if(fb) fb.disabled=b.n===0;
        foot.classList.toggle('is-on', b.n>0);
      }
      if(mode==='unified'){
        try{ var _sv=b.totalSaved>0?fmtMoney(b.totalSaved):'', _cmp=b.totalSaved>0?fmtMoney(b.compareSub):'';
          window.__cvBundle=window.__cvBundle||{}; window.__cvBundle[sid]={n:b.n, total:fmtMoney(b.totalNow), totalCents:b.totalNow, saved:_sv, compare:_cmp, add:function(){ return addBundle(null); }};
          document.dispatchEvent(new CustomEvent('cv:bundle',{detail:{sid:sid, n:b.n, total:fmtMoney(b.totalNow), totalCents:b.totalNow, saved:_sv, compare:_cmp}})); }catch(e){}
      }
      if(fab){
        var c=fab.querySelector('[data-abx-fab-count]'), t=fab.querySelector('[data-abx-fab-total]'), sv=fab.querySelector('[data-abx-fab-save]'), strip=fab.querySelector('[data-abx-fab-strip]'),
            dot=fab.querySelector('[data-abx-fab-dot]'), lines=fab.querySelector('[data-abx-fab-lines]');
        if(c) c.textContent=(b.n>0?('+'+b.n+(b.n===1?' add-on':' add-ons')):(label||'')); if(t) t.textContent=fmtMoney(b.totalNow); if(sv) sv.textContent=b.totalSaved>0?fmtMoney(b.compareSub):''; renderStrip(strip);
        var kt=fab.querySelector('[data-abx-fab-kit]'); if(kt){ var _kk=kitData(); kt.textContent=_kk ? (_kk.label + (_kk.colour ? (' · ' + _kk.colour) : '')) : 'Bundle'; }
        var itm=fab.querySelector('[data-abx-fab-itemsm]'); if(itm){ var _ti=(b.n||0)+1; itm.textContent='Your bundle ('+_ti+(_ti===1?' item':' items')+')'; }
        if(dot) dot.textContent = b.n>0 ? ('+'+b.n) : '';
        var dotm=fab.querySelector('[data-abx-fab-dotm]'); if(dotm) dotm.textContent = b.n>0 ? ('+'+b.n) : '';
        var trow=fab.querySelector('[data-abx-fab-timer]');
        if(trow){
          var _findcd=function(){ var a=[].slice.call(document.querySelectorAll('.cv-timer-cd')); return a.filter(function(e){ return /[1-9]/.test(e.textContent); })[0]||null; };
          var _synctimer=function(){ var c=_findcd(), x=trow.querySelector('[data-abx-fab-timercd]'); if(c&&x){ x.textContent=c.textContent.replace(/\s+/g,'').replace(/([a-z])(\d)/gi,'$1 $2'); trow.hidden=false; } else { trow.hidden=true; } };
          _synctimer();
          if(!trow.__tsync){ trow.__tsync=setInterval(_synctimer, 1000); }
        }
        setHTMLDiff(lines, footLinesHTML(b));
        updateFab();
      }
    }

    function toggleSelect(tile){
      var v=vidOf(tile); if(!v) return;
      if(selected[v]){ delete selected[v]; tile.classList.remove('is-selected'); setLabel(tile, L.set); }
      else { selected[v]=tile; tile.classList.add('is-selected'); setLabel(tile, L.sel); }
      refreshBundleUI(); ensurePoll(); paintAllTilePrices();
    }
    function clearSel(){ selected={}; rail.querySelectorAll('.abx-tile.is-added').forEach(function(t){ t.classList.remove('is-added'); }); refreshBundleUI(); ensurePoll(); paintAllTilePrices(); }

    function instantAdd(tile){
      if(tile.classList.contains('is-loading')) return;
      var v=vidOf(tile); if(!v) return;
      tile.classList.add('is-loading');
      addItems([{id:v,quantity:1}]).then(function(){
        tile.classList.remove('is-loading'); tile.classList.add('is-added'); setLabel(tile, L.added);
        setTimeout(function(){ tile.classList.remove('is-added'); setLabel(tile, L.add); }, 2200);
      }).catch(function(){ tile.classList.remove('is-loading'); });
    }
    function addToBundle(tile){
      var v=vidOf(tile); if(!v) return;
      if(selected[v]){ selected[v].qty++; }
      else {
        var raw=parseInt(tile.getAttribute('data-price'),10)||0;
        var nm=(tile.getAttribute('data-title')||'Add-on').replace(/\s*[-–—]\s*works\s+with\b[^]*$/i,'').trim();
        var onSw=tile.querySelector('[data-abx-swatch].is-on'); var sub=onSw?fmtColorName(onSw.getAttribute('data-name')):'';
        var im=tile.querySelector('.abx-tile__img');
        selected[v]={price:raw, compare:(parseInt(tile.getAttribute('data-compare'),10)||0), name:nm, sub:sub, img:(im?im.getAttribute('src'):''), qty:1, isKitAddon:tile.getAttribute('data-abx-kit')==='1'};
      }
      refreshBundleUI(); ensurePoll(); paintAllTilePrices();
      var txtEl=tile.querySelector('.abx-tile__cta-txt'), orig=txtEl?txtEl.textContent:'';
      tile.classList.add('is-added'); if(txtEl) txtEl.textContent=L.added;
      if(tile.__abxR) clearTimeout(tile.__abxR);
      tile.__abxR=setTimeout(function(){ tile.classList.remove('is-added'); if(txtEl) txtEl.textContent=orig; }, 1400);
    }

    var pop=null, popState=null;
    function pickSwatch(sw){
      var tile=sw.closest('[data-abx-tile]'); if(!tile || sw.classList.contains('is-soldout')) return;
      var oldVid=vidOf(tile);
      var nv=parseInt(sw.getAttribute('data-vid'),10), np=parseInt(sw.getAttribute('data-price'),10)||0;
      tile.setAttribute('data-vid', nv); tile.setAttribute('data-price', np); tile.setAttribute('data-compare', parseInt(sw.getAttribute('data-compare'),10)||0);
      var grp=sw.closest('[data-abx-sw]'); if(grp) grp.querySelectorAll('[data-abx-swatch]').forEach(function(x){ x.classList.toggle('is-on', x===sw); });
      paintTilePrice(tile);
      var ti=tile.querySelector('[data-abx-tileimg]'), di=sw.getAttribute('data-img'); if(ti && di) ti.src=di;
      var st=tile.querySelector('[data-abx-stock]'), q=parseInt(sw.getAttribute('data-qty'),10);
      if(st) st.textContent=(!isNaN(q)&&q>0&&q<=5)?('Only '+q+' left'):'';
      var swn=tile.querySelector('[data-abx-swname]'); if(swn) swn.textContent=fmtColorName(sw.getAttribute('data-name'));
      if(tile.classList.contains('is-selected')){ if(selected[oldVid]===tile) delete selected[oldVid]; selected[nv]=tile; refreshBundleUI(); }
    }
    function setupPop(){
      pop=root.querySelector('[data-abx-popup]'); if(!pop) return;
      pop.style.setProperty('--abx-accent', getComputedStyle(root).getPropertyValue('--abx-accent'));
      document.body.appendChild(pop);
      pop.querySelectorAll('[data-abx-pop-close]').forEach(function(b){ b.addEventListener('click', closePop); });
      var pv=pop.querySelector('[data-abx-pop-prev]'), nx=pop.querySelector('[data-abx-pop-next]');
      if(pv) pv.addEventListener('click', function(){ popGo(-1); });
      if(nx) nx.addEventListener('click', function(){ popGo(1); });
      var th=pop.querySelector('[data-abx-pop-thumbs]'); if(th) th.addEventListener('click', function(ev){ var t=ev.target.closest('[data-i]'); if(t) popSet(parseInt(t.getAttribute('data-i'),10)); });
      document.addEventListener('keydown', function(ev){ if(pop && !pop.hidden && ev.key==='Escape') closePop(); });
    }
    function openPop(tile){
      if(!pop) return;
      var dataEl=tile.querySelector('[data-abx-pop]'); if(!dataEl) return;
      var d; try{ d=JSON.parse(dataEl.textContent); }catch(e){ return; }
      var onSw=tile.querySelector('[data-abx-swatch].is-on'), curName=onSw?onSw.getAttribute('data-name'):'';
      var imgs=d.imgs||[], idx=0; imgs.forEach(function(im,i){ if(im.c===curName) idx=i; });
      popState={ imgs:imgs, idx:idx, tile:tile };
      pop.querySelector('[data-abx-pop-title]').textContent=d.title||'';
      var dn=pop.querySelector('[data-abx-pop-desc]'); dn.textContent=d.desc||''; dn.style.display=d.desc?'':'none';
      var lk=pop.querySelector('[data-abx-pop-link]'); if(lk){ if(d.url){ lk.href=d.url; lk.hidden=false; } else { lk.hidden=true; } }
      var inc=pop.querySelector('[data-abx-pop-incl]'); inc.innerHTML=d.incl||''; inc.style.display=(d.incl&&d.incl.indexOf('<li>')>-1)?'':'none';
      pop.querySelector('[data-abx-pop-thumbs]').innerHTML=imgs.map(function(im,i){ return '<button type="button" class="abx-pop__thumb'+(i===idx?' is-on':'')+'" data-i="'+i+'"><img src="'+(im.th||'')+'" alt="'+(im.c||'')+'"></button>'; }).join('');
      var multi=imgs.length>1; pop.querySelector('[data-abx-pop-prev]').style.display=multi?'':'none'; pop.querySelector('[data-abx-pop-next]').style.display=multi?'':'none';
      popPaint(); pop.hidden=false;
    }
    function popPaint(){
      if(!popState) return; var im=popState.imgs[popState.idx]; if(!im) return;
      var ig=pop.querySelector('[data-abx-pop-img]'); ig.src=im.big||im.th||''; ig.alt=im.c||'';
      var cl=pop.querySelector('[data-abx-pop-colour]'); if(cl){ var cn=im.c||''; var isDefault=cn==='Default Title'||cn===''; cl.textContent=isDefault?'':fmtColorName(cn); cl.style.display=isDefault?'none':''; }
      pop.querySelectorAll('.abx-pop__thumb').forEach(function(b,i){ b.classList.toggle('is-on', i===popState.idx); });
    }
    function popGo(dir){ if(!popState||!popState.imgs.length) return; var n=popState.imgs.length; popState.idx=(popState.idx+dir+n)%n; popSyncTile(); popPaint(); }
    function popSet(i){ if(!popState) return; popState.idx=i; popSyncTile(); popPaint(); }
    function popSyncTile(){ var im=popState.imgs[popState.idx], tile=popState.tile; if(!im||!tile) return; var sws=tile.querySelectorAll('[data-abx-swatch]'); for(var k=0;k<sws.length;k++){ if(sws[k].getAttribute('data-name')===im.c){ if(!sws[k].classList.contains('is-on')) pickSwatch(sws[k]); break; } } }
    function closePop(){ if(pop) pop.hidden=true; }

    function setupAtc(){
      atcOrig = document.querySelector('.cv-ps-'+sid+' .cv-atc') || document.querySelector('.cv-atc'); if(!atcOrig) return;
      if(mode!=='unified') return;
      document.querySelectorAll('.abx-atc-cta[data-abx-sid="'+sid+'"]').forEach(function(e){ e.remove(); });
      var tpl=root.querySelector('[data-abx-atc-tpl]');
      atcCta = tpl ? tpl.content.firstElementChild.cloneNode(true) : null;
      if(!atcCta) return;
      atcCta.setAttribute('data-abx-sid', sid);
      atcCta.style.setProperty('--abx-accent', getComputedStyle(root).getPropertyValue('--abx-accent'));
      atcCta.style.display='none';
      atcOrig.insertAdjacentElement('afterend', atcCta);
      atcCta.addEventListener('click', function(){ addBundle(atcCta); });
    }

    function setupFab(){
      if(mode!=='unified' && !bundleFab) return;
      fab = root.querySelector('[data-abx-fab]'); if(!fab) return;
      if(!fab.__abxSumWired){ fab.__abxSumWired=1; fab.addEventListener('click', onSummaryClick); }
      document.querySelectorAll('.abx-fab[data-abx-fab-sid="'+sid+'"]').forEach(function(e){ if(e!==fab) e.remove(); });
      fab.style.setProperty('--abx-accent', getComputedStyle(root).getPropertyValue('--abx-accent'));
      document.body.appendChild(fab);
      var fb=fab.querySelector('[data-abx-fab-btn]'); if(fb) fb.addEventListener('click', function(){ addBundle(fb); });
      var tg=fab.querySelector('[data-abx-fab-toggle]');
      if(tg) tg.addEventListener('click', function(){ var open=fab.classList.toggle('is-open'); tg.setAttribute('aria-expanded', open?'true':'false'); });
      var sentinel=document.getElementById('cv-atc-sentinel-'+sid);
      if(sentinel && 'IntersectionObserver' in W){
        new IntersectionObserver(function(es){ es.forEach(function(e){ pastBuyBox = e.boundingClientRect.bottom < 0; updateFab(); }); }).observe(sentinel);
      }
      W.addEventListener('scroll', function(){ if(sentinel){ pastBuyBox = sentinel.getBoundingClientRect().bottom < 0; updateFab(); } }, {passive:true});
    }
    function updateFab(){
      if((mode!=='unified' && !bundleFab) || !fab) return;
      var armed = tierAllowed && selVids().length>0;
      var show = armed && pastBuyBox;
      if(show){ fab.hidden=false; fab.offsetHeight; fab.classList.add('abx-fab--show'); }
      else{ fab.classList.remove('abx-fab--show'); fab.classList.remove('is-open'); var tg=fab.querySelector('[data-abx-fab-toggle]'); if(tg) tg.setAttribute('aria-expanded','false'); }
      window.__cvFabOn = window.__cvFabOn || {}; window.__cvFabOn[sid] = armed;
      var selBar=document.getElementById('cv-sticky-bar-'+sid);
      if(selBar){ if(armed) selBar.classList.remove('cv-bar--show'); selBar.style.display=''; }
    }

    function ensurePoll(){
      var armed=selVids().length>0;
      if(armed && !pollTimer && bundleMode){ pollTimer=setInterval(refreshBundleUI, 600); }
      else if(!armed && pollTimer){ clearInterval(pollTimer); pollTimer=null; }
    }

    function discData(){
      var d=alpineData(); if(!d) return null;
      var on=false; try{ on=!!d.discountApplied; }catch(e){}
      if(!on || typeof d._discountPrice!=='function') return null;
      return d;
    }
    function fmtSel(d,c){ try{ return d&&d.fw?d.fw(c):money(c,cur); }catch(e){ return money(c,cur); } }
    var ABX_BONUS_PCT = (window.__abxCfg && window.__abxCfg.bundleExtraPct != null) ? +window.__abxCfg.bundleExtraPct : 0, ABX_BONUS_MIN_QTY = 3;
    function cartQtyNow(){
      var n = 0;
      try{ var c = W.Alpine && Alpine.store && Alpine.store('xCartHelper');
           if(c && +c.currentItemCount > 0) n = +c.currentItemCount; }catch(e){}
      if(!n){ try{ var b = document.querySelector('#cart-icon-bubble span');
                   if(b) n = parseInt(b.textContent, 10) || 0; }catch(e){} }
      return n;
    }
    function stagedQty(){ var n=0;
      try{ Object.keys(selected).forEach(function(v){ n += (selected[v] && selected[v].qty) || 1; }); }catch(e){}
      return n; }
    function bonusEarned(){ try{ return (cartQtyNow() + stagedQty()) >= ABX_BONUS_MIN_QTY; }catch(e){ return false; } }
    function bonusOnAdd(){ try{ return (cartQtyNow() + stagedQty() + 1) >= ABX_BONUS_MIN_QTY; }catch(e){ return false; } }
    function pillPct(){ return ADDON_PCT + (bonusEarned() ? ABX_BONUS_PCT : 0); }
    function paintTilePrice(tile){
      var raw=parseInt(tile.getAttribute('data-price'),10)||0;
      var nowEl=tile.querySelector('[data-abx-price]'), wasEl=tile.querySelector('[data-abx-was]'), pill=tile.querySelector('[data-abx-savepill]');
      var d=discData();
      var _isKit = tile.getAttribute('data-abx-kit')==='1';
      function _kitPct(r){ if(!d||r<=0) return 0; try{ var x=d._discountPrice(r); return x<r?Math.round((r-x)/r*100):0; }catch(e){ return 0; } }
      function _kitNow(r){ if(!d) return r; try{ var x=d._discountPrice(r); return x<r?x:r; }catch(e){ return r; } }
      function _baseKitPct(){ if(!d) return 0; try{ var e=d.discMap&&d.discMap['m']; if(!e) return 0; return (e.t||'percent')==='percent'?e.v:0; }catch(e){ return 0; } }
      if(_isKit){
        var _kd=_kitNow(raw);
        var _kitSave=raw-_kd;
        if(pill){ pill.textContent=_kitSave>0?(fmtSel(d,_kitSave)+' off'):''; pill.hidden=_kitSave<=0; }
        if(nowEl) nowEl.textContent=fmtSel(d,_kd);
        if(wasEl){ wasEl.textContent=fmtSel(d,raw); wasEl.hidden = !(_kd<raw); }
        return;
      }
      if(raw<=0){
        if(pill) pill.hidden=true;
        if(nowEl) nowEl.textContent=money(raw,cur);
        if(wasEl) wasEl.hidden=true;
        return;
      }
      var _cmp=parseInt(tile.getAttribute('data-compare'),10)||0;
      if(_cmp>raw){
        if(pill){ pill.textContent=fmtSel(d,_cmp-raw)+' off'; pill.hidden=false; }
        if(nowEl) nowEl.textContent=fmtSel(d,raw);
        if(wasEl){ wasEl.textContent=fmtSel(d,_cmp); wasEl.hidden=false; }
        return;
      }
      if(ADDON_PCT<=0){
        if(pill) pill.hidden=true;
        if(nowEl) nowEl.textContent=fmtSel(d,raw);
        if(wasEl) wasEl.hidden=true;
        return;
      }
      var disc=addonDiscCents(raw);
      var _addonSave=raw-disc;
      if(pill){ pill.textContent=_addonSave>0?(fmtSel(d,_addonSave)+' off'):''; pill.hidden=_addonSave<=0; }
      if(nowEl) nowEl.textContent=fmtSel(d,disc);
      if(wasEl){ wasEl.textContent=fmtSel(d,raw); wasEl.hidden=false; }
    }
    function paintAllTilePrices(){ try{ rail.querySelectorAll('.abx-tile').forEach(paintTilePrice); }catch(e){} }
    function fmtColorName(raw){ if(!raw||raw==='Default Title') return ''; var d=alpineData(); if(d&&typeof d.fmtColor==='function'){ try{ return d.fmtColor(raw); }catch(e){} } var n=String(raw).replace(/\s*\(PMS[^)]*\)\s*/i,'').replace(/\s*\([^)]*\)\s*$/,'').trim(); var m=n.match(/^Frosted\s+(.+)$/i); return m?(m[1]+' Frosted'):n; }
    function formatSwNames(){ try{ rail.querySelectorAll('[data-abx-tile]').forEach(function(t){ var on=t.querySelector('[data-abx-swatch].is-on'), swn=t.querySelector('[data-abx-swname]'); if(on&&swn) swn.textContent=fmtColorName(on.getAttribute('data-name')); }); }catch(e){} }
    function prime(){
      if(bundleMode){ rail.querySelectorAll('.abx-tile:not(.is-added) .abx-tile__cta-txt').forEach(function(t){ t.textContent='Add to bundle'; }); }
      rail.querySelectorAll('.abx-tile--size').forEach(function(t){ var on=t.querySelector('[data-abx-swatch].is-on'), st=t.querySelector('[data-abx-stock]'); if(on&&st){ var q=parseInt(on.getAttribute('data-qty'),10); st.textContent=(!isNaN(q)&&q>0&&q<=5)?('Only '+q+' left'):''; } });
      formatSwNames();
    }
    prime();
    setTimeout(formatSwNames, 700);

    rail.addEventListener('click', function(ev){
      var sw=ev.target.closest('[data-abx-swatch]'); if(sw){ ev.preventDefault(); pickSwatch(sw); return; }
      var info=ev.target.closest('[data-abx-info]'); if(info){ ev.preventDefault(); openPop(ev.target.closest('[data-abx-tile]')); return; }
      var cta=ev.target.closest('[data-abx-cta]'), tile=ev.target.closest('[data-abx-tile]'); if(!tile) return;
      if(mode==='instant'){ if(cta){ ev.preventDefault(); instantAdd(tile); } return; }
      ev.preventDefault(); addToBundle(tile);
    });
    function onSummaryClick(ev){
      if(ev.target.closest('[data-abx-disc-toggle]')){
        ev.preventDefault();
        var ad=alpineData();
        var wasOn=ad&&ad.discountApplied;
        if(ad){
          if(wasOn){ ad.removeDiscount(); } else { ad.applyDiscount(); }
        } else {
          var discBtn=document.querySelector('.cv-ps-'+sid+' .cv-disc-check');
          if(discBtn) discBtn.click();
        }
        var chk=ev.target.closest('[data-abx-disc-toggle]');
        var row=chk?chk.closest('.abx__fl--badge'):null;
        if(row){
          row.classList.toggle('abx__fl--disc-off',wasOn);
          if(chk) chk.classList.toggle('is-off',wasOn);
        }
        setTimeout(function(){ refreshBundleUI(); paintAllTilePrices(); }, 80);
        return;
      }
      var box=ev.target.closest('[data-abx-sum-vid]'); if(!box) return;
      var v=parseInt(box.getAttribute('data-abx-sum-vid'),10); if(!selected[v]){ return; }
      if(ev.target.closest('[data-abx-sum-inc]')){ selected[v].qty++; }
      else if(ev.target.closest('[data-abx-sum-dec]')){ if(--selected[v].qty<=0) delete selected[v]; }
      else if(ev.target.closest('[data-abx-sum-del]')){ delete selected[v]; }
      else { return; }
      ev.preventDefault(); refreshBundleUI(); ensurePoll(); paintAllTilePrices();
    }
    if(foot) foot.addEventListener('click', onSummaryClick);
    rail.addEventListener('change', function(ev){
      var sel=ev.target.closest('[data-abx-swselect]'); if(!sel) return;
      var tile=sel.closest('[data-abx-tile]'); if(!tile) return;
      var sw=tile.querySelector('[data-abx-swatch][data-vid="'+sel.value+'"]'); if(sw) pickSwatch(sw);
    });

    if(foot){ var fb=foot.querySelector('[data-abx-foot-btn]'); if(fb) fb.addEventListener('click', function(){ addBundle(fb); }); }

    setupPop();
    if(bundleMode){ setupAtc(); setupFab(); }

    var showTiers = (root.getAttribute('data-abx-show-tiers')||'all');
    var allowAll = showTiers.indexOf('all')>=0;
    function normTier(x){ x=String(x||'').replace(/\s+/g,''); if(x.indexOf('24')>=0||x==='s')return 's'; if(x.indexOf('46')>=0||x==='m')return 'm'; if(x.indexOf('70')>=0||x==='l')return 'l'; if(x.indexOf('92')>=0||x==='xl')return 'xl'; return x; }
    var allowSet = showTiers.split(',').map(normTier);
    function tierOfSize(sz){ sz=String(sz||''); if(sz.indexOf('24')>=0)return 's'; if(sz.indexOf('46')>=0)return 'm'; if(sz.indexOf('70')>=0)return 'l'; if(sz.indexOf('92')>=0)return 'xl'; return ''; }
    function curSize(){ var d=alpineData(); if(!d) return ''; try{ return d.selectedSize||''; }catch(e){ return ''; } }
    function applyTierVis(sz){
      if(allowAll){ tierAllowed=true; root.style.display=''; return; }
      var t=tierOfSize(sz);
      if(!t){ tierAllowed=true; root.style.display=''; return; }
      var ok=allowSet.indexOf(t)>=0;
      tierAllowed=ok;
      root.style.display = ok ? '' : 'none';
      if(!ok && bundleMode){ clearSel(); }
      updateFab();
    }
    document.addEventListener('cv:size-change', function(ev){ applyTierVis(ev&&ev.detail&&ev.detail.size!=null?ev.detail.size:curSize()); paintAllTilePrices(); });
    document.addEventListener('cv:color-change', function(ev){
      var c=ev&&ev.detail&&ev.detail.color; if(!c) return;
      rail.querySelectorAll('.abx-tile--size').forEach(function(tile){
        var sw=tile.querySelector('[data-abx-swatch][data-name="'+c.replace(/"/g,'')+'"]');
        if(sw && !sw.classList.contains('is-on')) pickSwatch(sw);
      });
    });
    applyTierVis(curSize()); paintAllTilePrices();
    setTimeout(function(){ applyTierVis(curSize()); paintAllTilePrices(); }, 500);
    setTimeout(function(){ applyTierVis(curSize()); paintAllTilePrices(); }, 1500);
    setTimeout(paintAllTilePrices, 2600);

    function step(){ var t=rail.querySelector('.abx-tile'); return t ? (t.getBoundingClientRect().width*2 + 20) : rail.clientWidth*0.8; }
    function syncArrows(){
      var over = rail.scrollWidth - rail.clientWidth > 4;
      root.classList.toggle('is-overflow', over);
      if(prev) prev.disabled = rail.scrollLeft <= 2;
      if(next) next.disabled = rail.scrollLeft >= (rail.scrollWidth - rail.clientWidth - 2);
    }
    if(prev) prev.addEventListener('click', function(){ rail.scrollBy({left:-step(),behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ rail.scrollBy({left:step(),behavior:'smooth'}); });
    rail.addEventListener('scroll', syncArrows, {passive:true});
    W.addEventListener('resize', syncArrows);

    function loadRecs(){
      var url=root.getAttribute('data-rec-url'), pid=root.getAttribute('data-pid'),
          lim=root.getAttribute('data-rec-limit')||'6', sec=root.getAttribute('data-rec-section')||'ab-addon-recs';
      if(!url||!pid){ hideOrEmpty(); return; }
      fetch(url+'?section_id='+sec+'&product_id='+pid+'&limit='+lim+'&intent=related',{credentials:'same-origin'})
        .then(function(r){ return r.text(); })
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var tiles=doc.querySelectorAll('[data-abx-tile]');
          var sk=rail.querySelector('[data-abx-skeleton]');
          if(!tiles.length){ if(sk) sk.remove(); hideOrEmpty(); return; }
          tiles.forEach(function(n){ var node=document.importNode(n,true); if(sk){ rail.insertBefore(node, sk); } else { rail.appendChild(node); } });
          if(sk) sk.remove();
          prime(); paintAllTilePrices(); syncArrows();
        })
        .catch(function(){ hideOrEmpty(); });
    }
    function hideOrEmpty(){
      var sk=rail.querySelector('[data-abx-skeleton]'); if(sk) sk.remove();
      if(rail.querySelector('.abx-tile')) return;
      if(document.documentElement.classList.contains('shopify-design-mode') || W.Shopify && Shopify.designMode){
        rail.innerHTML='<div class="abx__empty" style="flex:1">No related products yet. Pick a Manual list or a Collection instead.</div>';
      } else { root.style.display='none'; }
    }
    if(rail.querySelector('[data-abx-skeleton]')){
      if('IntersectionObserver' in W){
        var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ io.disconnect(); loadRecs(); } }); }, {rootMargin:'300px'});
        io.observe(root);
      } else { loadRecs(); }
    }

    requestAnimationFrame(syncArrows);
    setTimeout(syncArrows, 800);
    if(!root.__footCdSync){
      var _fcd=function(){ var rs=[].slice.call(root.querySelectorAll('[data-abx-foot-cdrow]')), txs=[].slice.call(root.querySelectorAll('[data-abx-foot-cdtxt]')), c=[].slice.call(document.querySelectorAll('.cv-timer-cd')).filter(function(e){ return /[1-9]/.test(e.textContent); })[0]||null; var cdTxt=c&&/\d/.test(c.textContent)?c.textContent.replace(/\s+/g,'').replace(/([a-z])(\d)/gi,'$1 $2'):null; rs.forEach(function(r,i){ if(cdTxt){ if(txs[i]) txs[i].textContent=cdTxt; r.hidden=false; }else{ r.hidden=true; } }); };
      _fcd(); root.__footCdSync=setInterval(_fcd,1000);
    }
    if(root.getAttribute('data-abx-collapsible')==='true' && !root.__abxAcc){
      root.__abxAcc=1;
      var _accBtn=root.querySelector('[data-abx-acc-toggle]'), _accPv=root.querySelector('[data-abx-preview]');
      var _accCap=function(){ try{ return window.matchMedia('(min-width:1280px)').matches?5:4; }catch(e){ return 4; } };
      var _accPaint=function(){ if(!_accPv) return; var CAP=_accCap(); var ims=rail.querySelectorAll('.abx-tile img'), h='', n=0, i, s; for(i=0;i<ims.length;i++){ s=ims[i].getAttribute('src')||ims[i].src||''; if(!s) continue;
h+='<span class="abx__pv-t"><img src="'+s+'" alt="" loading="lazy" decoding="async"></span>'; if(++n>=CAP) break; } if(ims.length>CAP){ h+='<span class="abx__pv-more">+'+(ims.length-CAP)+'</span>'; } _accPv.innerHTML=h; };
      try{ var _accMQ=window.matchMedia('(min-width:1280px)'); if(_accMQ.addEventListener) _accMQ.addEventListener('change',_accPaint); else if(_accMQ.addListener) _accMQ.addListener(_accPaint); }catch(e){}
      if(_accBtn){ var _accTxt=_accBtn.querySelector('.abx__acc-txt'); var _setLbl=function(open){ var l=open?_accBtn.getAttribute('data-hide'):_accBtn.getAttribute('data-view'); if(l){ if(_accTxt) _accTxt.textContent=l; _accBtn.setAttribute('aria-label',l); } }; var _accToggle=function(){ if(root.hasAttribute('data-abx-collapsed')){ root.removeAttribute('data-abx-collapsed'); _accBtn.setAttribute('aria-expanded','true'); _setLbl(true); } else { root.setAttribute('data-abx-collapsed',''); _accBtn.setAttribute('aria-expanded','false'); _setLbl(false); _accPaint(); } }; _accBtn.addEventListener('click', _accToggle); if(_accPv){ _accPv.addEventListener('click', _accToggle); _accPv.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); _accToggle(); } }); } }
      _accPaint();
      try{ new MutationObserver(_accPaint).observe(rail,{childList:true,subtree:true}); }catch(e){}
    }
    refreshBundleUI();
  }

  function scan(){ document.querySelectorAll('.abx[data-abx-root]').forEach(wire); }
  window.__abxAddonScan = scan;
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
})();
